var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSizemdPaymentmethodGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4103 20.704V16.7911H23.4298C24.2574 16.7911 24.9558 16.5138 25.5252 15.967L25.6619 15.8283C26.702 14.696 26.6337 12.9322 25.5252 11.8846C24.971 11.3301 24.2118 11.0297 23.4298 11.0451H20.188V20.704H21.4103ZM21.4105 15.6049V12.2312H23.4607C23.9011 12.2312 24.3187 12.4006 24.63 12.7087C25.2906 13.3557 25.3058 14.4341 24.668 15.1042C24.3567 15.4354 23.9163 15.6203 23.4607 15.6049H21.4105ZM31.3636 14.6113C30.8398 14.126 30.1261 13.8795 29.2226 13.8795C28.061 13.8795 27.188 14.3109 26.611 15.1659L27.689 15.8514C28.0838 15.266 28.6229 14.9733 29.3062 14.9733C29.7389 14.9733 30.1565 15.1351 30.4829 15.4277C30.8018 15.705 30.984 16.1056 30.984 16.5292V16.8142C30.5133 16.5523 29.9211 16.4137 29.1923 16.4137C28.342 16.4137 27.6587 16.6139 27.15 17.0222C26.6413 17.4304 26.3832 17.9696 26.3832 18.6551C26.368 19.279 26.6337 19.8721 27.1044 20.2726C27.5827 20.704 28.1901 20.9196 28.9038 20.9196C29.7465 20.9196 30.4146 20.5422 30.9233 19.7874H30.9764V20.704H32.1456V16.6293C32.1456 15.7744 31.8875 15.0965 31.3636 14.6113ZM28.0461 19.487C27.7955 19.3021 27.6436 19.0017 27.6436 18.6782C27.6436 18.3162 27.8107 18.0158 28.1372 17.777C28.4713 17.5383 28.8889 17.415 29.3825 17.415C30.0659 17.4073 30.5974 17.5614 30.9771 17.8695C30.9771 18.3932 30.7721 18.8477 30.3696 19.2328C30.0051 19.6025 29.5116 19.8105 28.9952 19.8105C28.6535 19.8182 28.3194 19.7027 28.0461 19.487ZM34.7725 23.6078L38.8571 14.0952H37.5284L35.638 18.8399H35.6152L33.6792 14.0952H32.3506L35.0306 20.2803L33.5122 23.6078H34.7725Z",
    fill: "#3C4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1905 15.9438C17.1905 15.5664 17.1601 15.189 17.0994 14.8193H11.9443V16.9529H14.8977C14.7762 17.6384 14.3814 18.2546 13.8044 18.6397V20.0262H15.5658C16.5983 19.0634 17.1905 17.6384 17.1905 15.9438Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9445 21.3664C13.4173 21.3664 14.6625 20.8734 15.5659 20.0262L13.8045 18.6397C13.3111 18.9786 12.6809 19.1712 11.9445 19.1712C10.5172 19.1712 9.31001 18.193 8.87726 16.8835H7.06274V18.3162C7.98898 20.1879 9.87942 21.3664 11.9445 21.3664Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87746 16.8836C8.64966 16.198 8.64966 15.4509 8.87746 14.7577V13.3327H7.06266C6.28055 14.8963 6.28055 16.7449 7.06266 18.3085L8.87746 16.8836Z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9445 12.47C12.7265 12.4546 13.4781 12.755 14.0399 13.3019L15.6039 11.7152C14.6093 10.7755 13.3035 10.2594 11.9445 10.2748C9.87942 10.2748 7.98898 11.461 7.06274 13.3327L8.87726 14.7654C9.31001 13.4482 10.5172 12.47 11.9445 12.47Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizemdPaymentmethodGooglePay);
export default __webpack_public_path__ + "static/media/Size=md, Payment method=GooglePay.0c393f18.svg";
export { ForwardRef as ReactComponent };